import axios from 'axios'
import * as auth from './auth.js'
import * as users from './users.js'
import * as api from './api.js'
import * as webinars from './webinars.js'
import * as subscriptions from './subscriptions.js'
import * as quiz from './quiz.js';
import * as suggestions from './suggestions.js';
import * as requests from './requests.js';
import * as mixed from './mixed.js';
import * as sponsors from './sponsors.js';
import constants from 'constants';

const {
  SHOW_MODAL,
  HIDE_MODAL
} = constants;

const showModal = (modalType, modalContentProps = {}) => ({
  type: SHOW_MODAL,
  modalType,
  modalContentProps
});

const hideModal = () => ({
  type: HIDE_MODAL
});

const actions = {
  showModal,
  hideModal
}

const globalActions = {
  ...auth,
  ...users,
  ...api,
  ...webinars,
  ...subscriptions,
  ...actions,
  ...quiz,
  ...suggestions,
  ...requests,
  ...mixed,
  ...sponsors
}
export default globalActions;



/** WEBPACK FOOTER **
 ** ./src/actions/index.js
 **/